import React from "react";
import {Box, Button, Typography,} from "@mui/material"
import {Trans} from "@lingui/macro"
import {Link} from "react-router-dom"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import {Error} from "@mui/icons-material"

export class PaymentError extends React.Component<{}, {}>{
	render()
	{
		return (<Box sx={{
			p: 2,
			bgcolor: process.env.REACT_APP_THIRD_COLOR,
		}}>
			<Box
				sx={{
					marginTop: 8,
					display: " flex",
					flexDirection: " column",
					alignItems: " center",
				}}
			>
				<Error color="error" sx={{fontSize: 120}} />
				<Typography mt={2} mb={5} variant="h3" sx={{color: "white"}}>
					<Trans id="checkout-error" comment="">Si è verificato un errore nel pagamento</Trans>
				</Typography>
				<Box component={"div"} display={"flex"} justifyContent={"center"}>
					<Link to="/subscribe/">
						<Button variant="contained" startIcon={<ArrowBackIcon />}>
							<Trans id="checkout-error-back" comment="Go to subscribe"> Torna alla lista lista abbonamenti </Trans>
						</Button>
					</Link>
				</Box>
			</Box>
		</Box>)
	}
}
